import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";
import { Nullable } from "@/Common/interfaces/types";

export async function requestPtoBalanceIngestion(locationId: string, commissionCycleId: string, payPeriodId: string) {
	const query = gql`
		mutation requestPtoBalanceIngestion($commissionCycleId: String!, $locationId: String!, $payPeriodId: String!) {
			requestPtoBalanceIngestion(commissionCycleId: $commissionCycleId, locationId: $locationId, payPeriodId: $payPeriodId)
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.requestPtoBalanceIngestion;
	} catch (err) {
		errorLogger(err as Error, {
			function: "requestPtoBalanceIngestion",
			message: "Failed to request PTO balance ingestion",
			variables,
		});
		return null;
	}
}

export async function requestWorkedHoursIngestion(locationId: string, commissionCycleId: Nullable<string>, payPeriodId: Nullable<string>) {
	const query = gql`
		mutation requestWorkedHoursIngestion($commissionCycleId: String!, $locationId: String!, $payPeriodId: String!) {
			requestWorkedHoursIngestion(commissionCycleId: $commissionCycleId, locationId: $locationId, payPeriodId: $payPeriodId)
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.requestWorkedHoursIngestion;
	} catch (err) {
		errorLogger(err as Error, {
			function: "requestWorkedHoursIngestion",
			message: "Failed to request worked hours ingestion",
			variables,
		});
		return null;
	}
}

export async function payRateIngestion(locationId: string, commissionCycleId: Nullable<string>, payPeriodId: Nullable<string>) {
	const query = gql`
		mutation ingestPayRate($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!) {
			ingestPayRate(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId)
		}
	`;

	const variables = {
		commissionCycleId,
		locationId,
		payPeriodId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.ingestPayRate;
	} catch (err) {
		errorLogger(err as Error, { function: "payRateIngestion", message: "Failed to ingest pay rates", variables });
		return null;
	}
}

export async function requestPtoIngestion(locationId: string, commissionCycleId: string, payPeriodId: string) {
	const query = gql`
		mutation requestPtoIngestion($commissionCycleId: String!, $locationId: String!, $payPeriodId: String!) {
			requestPtoIngestion(commissionCycleId: $commissionCycleId, locationId: $locationId, payPeriodId: $payPeriodId)
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.requestPtoIngestion;
	} catch (err) {
		errorLogger(err as Error, { function: "requestPtoIngestion", message: "Failed to request PTO ingestion", variables });
		return null;
	}
}

export async function ingestManualTimecards(
	locationId: Nullable<string>,
	commissionCycleId: Nullable<string>,
	payPeriodId: Nullable<string>
) {
	const query = gql`
		mutation ingestManualTimecards($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!) {
			ingestManualTimecards(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId)
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		payPeriodId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.ingestManualTimecards;
	} catch (err) {
		errorLogger(err as Error, { function: "ingestManualTimecards", message: "Failed to ingest manual timecards", variables });
		return null;
	}
}
